import { render, staticRenderFns } from "./df-page-form-mail.vue?vue&type=template&id=656caa91"
import script from "./df-page-form-mail.ts?vue&type=script&lang=js&external"
export * from "./df-page-form-mail.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports